// ./src/components/features/BlockTransitionAnimationBadge/BlockTransitionAnimationBadge.tsx
import React from "react";
import { Badge, Group } from "@mantine/core";

export interface BlockTransitionAnimationBadgeProps {
  transitionType?: string | undefined | null;
}

const transitionAnimations: any = {
  fade: { label: "Fade" },
  "slide-left": { label: "Slide Left" },
  "slide-right": { label: "Slide Right" },
  "slide-up": { label: "Slide Up" },
  "slide-down": { label: "Slide Down" },
  scale: { label: "Scale" },
  "scale-rotate": { label: "Scale Rotate" },
  flip: { label: "Flip" },
  "flip-x": { label: "Flip X" },
  "zoom-out": { label: "Zoom Out" },
  "push-left": { label: "Push Left" },
  "push-right": { label: "Push Right" },
  curtain: { label: "Curtain" },
  blur: { label: "Blur" },
  bounce: { label: "Bounce" },
  none: { label: "None" },
  unknown: { label: "Unknown" },
};

export const BlockTransitionAnimationBadge: React.FC<
  BlockTransitionAnimationBadgeProps
> = ({ transitionType }) => {
  const transitionAnimation =
    transitionAnimations[transitionType || "unknown"] ||
    transitionAnimations["unknown"];

  return (
    <Group gap="xs" align="center" style={{ flexWrap: "nowrap" }}>
      <Badge variant="light" size="sm">
        {transitionAnimation.label}
      </Badge>
    </Group>
  );
};
